
import { defineComponent, ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import Fuse from "fuse.js";
import {
  ConfigUser,
  GetConfigUserResponse,
  UpsertConfigUserRequest,
  // GetConfigUserRequest,
} from "@/types";
import { equals, clone } from "ramda";

export default defineComponent({
  name: "ConfigUserScreen",
  setup() {
    const { axios, error, success, setLoading, formatAppDate } = usePlugin();
    const userConfigs = ref<ConfigUser[]>([]);
    const userConfigsTemp = ref<ConfigUser[]>([]);

    const searchString = ref("");
    const searchLevel = ref<string | null>(null);
    const levels = computed(() => {
      return [
        ...new Set(userConfigs.value.map((x) => x.employee?.level ?? "0")),
      ].sort();
    });
    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetConfigUserResponse>(
          "api/v1/services/configUser",
          {}
          // as GetConfigUserRequest
        );
        userConfigs.value = result.data.configUsers ?? [];
        userConfigsTemp.value = clone(userConfigs.value);
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveDocument = async () => {
      setLoading(true);
      try {
        for (const userConfig of userConfigs.value) {
          const userConfigTemp = userConfigsTemp.value.find(
            (x) => x.employeeId === userConfig.employeeId
          );
          if (!equals(userConfigTemp, userConfig)) {
            await axios.post("api/v1/services/configUser/upsert", {
              configUser: userConfig,
            } as UpsertConfigUserRequest);
          }
        }

        success("บันทึกข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const filteredUserConfigs = computed(() => {
      if (!searchString.value && !searchLevel.value) return userConfigs.value;

      let result = userConfigs.value;
      if (searchString.value) {
        const fuse = new Fuse(userConfigs.value, {
          keys: ["employeeId", "employee.name", "employee.surname"],
        });
        const fuzzyResult = fuse.search(searchString.value);
        result = fuzzyResult.map((x) => x.item);
      }
      if (searchLevel.value) {
        result = result.filter((x) => x.employee?.level === searchLevel.value);
      }
      return result;
    });

    const isDirty = computed(
      () => !equals(userConfigs.value, userConfigsTemp.value)
    );

    onMounted(() => loadDocument());

    return {
      filteredUserConfigs,
      userConfigs,
      formatAppDate,
      searchString,
      isDirty,
      onSaveDocument,
      levels,
      searchLevel,
    };
  },
});
